import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  LinkIcon
} from '../../components'
import Styles from './InlineSignup.css'

@CSSModules(Styles, {allowMultiple:true})
export default class InlineSignup extends Component {
  render() {
    return <div styleName='inline-signup' aria-labelledby='inline-signup__headline'>

      <div styleName='inline-signup__icon' aria-hidden='true'>
        <LinkIcon faclass='fa-envelope' nospace/>
      </div>

      <h3 id='inline-signup__headline' styleName='inline-signup__headline'>
        See the impact of your investments
      </h3>

      <h3 styleName='inline-signup__copy'>
        Regular updates on sustainability risks and ethical concerns in everyday investment products
      </h3>

      <div styleName='inline-signup__form-wrap'>
        <form
          styleName='inline-signup__form'
          acceptCharset='UTF-8'
          method='post'
          action={config.signupForm.url}
          target='signup_confirmation'
          ref={(el) => this.myInlineFormRef = el}
        >
          { /* FAKE FIELD FOR TRICKING BOTS */ }
          <div style={{
            position: 'absolute',
            left: '-9999px',
            top: '-9999px',
          }}>
            <label htmlFor='pardot_extra_field'>Comments</label>
            <input type='text' id='pardot_extra_field' name='pardot_extra_field' />
          </div>

          <label
            htmlFor={config.signupForm.id}
            style={{
              position: 'absolute',
              width: '1px',
              height: '1px',
              margin: '-1px',
              padding: '0',
              overflow: 'hidden',
              clip: 'rect(0, 0, 0, 0)',
              border: '0',
            }}
          >
            Email address
          </label>
          <input
            id={config.signupForm.id}
            styleName='inline-signup__input'
            name={config.signupForm.id}
            type='email'
            placeholder='Enter your email address'
            autocomplete='email'
            required
            aria-required='true'
          />

          <button
            styleName='inline-signup__submit'
            type='submit'
          >
            Sign up
          </button>

        </form>
      </div>

    </div>
  }
}
